import type { GalleryInfo } from '../types/gallery';

export const hasEventGallery = (gallery?: GalleryInfo | null): boolean =>
  !!gallery && Object.keys(gallery).length > 0;
